<template>
  <div id="app">
    <b-navbar sticky toggleable="md" type="dark" variant="info">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/"><img :src="logo" alt="PanEssex"/></b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/alerts">Notifications</b-nav-item>
          <b-nav-item to="/investigations">Investigations</b-nav-item>
          <b-nav-item to="/misnomers">Misnomers</b-nav-item>
          <b-nav-item to="/contacts">Contacts</b-nav-item>
          <!-- <b-nav-item href="https://version1.panessex.co.uk">Old Site</b-nav-item> -->
          <b-nav-item v-if="is_sysadmin" to="/support">Admin</b-nav-item>
        </b-navbar-nav>
        
        <!-- right-aligned items -->
        <b-navbar-nav class="ml-auto">
          <!-- logged-in user -->
          <b-nav-item-dropdown v-if="oidcUser" right>
            <template #button-content>
              {{ oidcUser | authority }}/{{ oidcUser.name }}
            </template>
            <b-dropdown-item :to="{name: 'extract-status'}">Extract Status</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-if="is_userManager" href="https://login.vigilantapps.com/Admin/User/New" target="_blank">Create new user&hellip;</b-dropdown-item>
            <b-dropdown-item v-if="is_userManager" href="https://login.vigilantapps.com/User/MyDetails" target="_blank">Edit my profile</b-dropdown-item>
            <b-dropdown-item @click="signOutOidc">Signout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container class="main-canvas">
      <countdown :interval="1200" @zero="signOutOidc"/>
      <router-view/>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Countdown from '@/components/Countdown.vue'

export default {
  components: { Countdown },
  computed: {
    ...mapGetters([
      'oidcUser',
    ]),
    logo() {
      return require('./assets/panessex-logo.png');
    },
    is_sysadmin() {
      return !this.oidcUser ? false : this.$hasRole(this.oidcUser, 'feature.sysadmin');
    },
    is_userManager() {
      return !this.oidcUser ? false : this.$hasRole(this.oidcUser, 'feature.userManager');
    },
  },
  methods: {
    ...mapActions([
      'signOutOidc',
    ]),
    dashboardLink(pageName) {
      return { name: 'dashboard', params: { pageName } };
    },
  },
};
</script>

<style scoped>
.bg-info {
    background-color: #333 !important;
}
</style>
